module.exports = __webpack_public_path__ + "img/folder-check.ddf5b808.svg";